import React, { useState, useContext } from 'react';
import { NowPlayingContext } from '../../contexts/now-playing.context';

import PodcastImage from '../podcast-image/PodcastImage';

import {
  EpisodeContainer,
  EpisodeData,
  EpisodeDescription,
  DescriptionBtn,
  PlayNow
} from './Episode.styled';

const Episode = ({ episode, author, authorId }) => {
  const [expandDescription, setExpandDescription] = useState(false);
  const { nowPlaying, isPlaying } = useContext(NowPlayingContext);

  const {
    title,
    thumbnail,
    pub_date_ms,
    audio_length_sec,
    description,
    id
  } = episode;
  const isLoadedNow = nowPlaying && nowPlaying.id === id;
  let date = new Date(pub_date_ms);
  date = date.toDateString().substring(4);

  let length = new Date(audio_length_sec * 1000).toISOString().substr(11, 8);

  return (
    <>
      <EpisodeContainer isLoadedNow={isLoadedNow}>
        <div style={{ minHeight: '5rem' }}>
          <PodcastImage url={thumbnail} alt={'thumbnail'} size="sm" />
        </div>
        <div>
          <h3>{title}</h3>
          <div>
            <EpisodeData>{date}</EpisodeData>
            <EpisodeData>{length}</EpisodeData>
            <DescriptionBtn
              onClick={() => setExpandDescription(!expandDescription)}
            >
              {`${expandDescription ? 'Close' : 'Description'} `}
            </DescriptionBtn>
          </div>
        </div>
        <PlayNow
          episode={episode}
          author={author}
          authorId={authorId}
          isLoaded={isLoadedNow}
          isPlaying={isPlaying}
        />
        {expandDescription && (
          <EpisodeDescription
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
      </EpisodeContainer>
    </>
  );
};

export default Episode;
